import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { MicrosoftIntuneService } from '../../service';

export type DeviceCompliancePolicyDefinitionConfig =
  typeof DeviceCompliancePolicyDefinitionConfig._.Config;

export const DeviceCompliancePolicyDefinitionConfig = IntegrationConfig.make({
  service: MicrosoftIntuneService,
  name: Integration_Handler_Names_Enum.DeviceCompliancePolicyDefinition,
  configSchema: z.object({
    policyId: z.uuid(),
  }),
});
